import { ApplicationController } from "../../application_controller"
import Rails from '@rails/ujs'

export default class extends ApplicationController {
    initialize() {}

    connect() {
	// Only run this for the element that has data-source-selector
	if (this.element.dataset.sourceSelector) {
	    this.setup()
	    this.connectHeadingObserver()
	}
    }

    disconnect() {
	// Only run this for the element that has data-source-selector
	if (this.element.dataset.sourceSelector) {
	    this.disconnectHeadingObserver()
	}
    }

    setup() {
	if (this.element.dataset.setupComplete == 'true') { return }

	var sourceElement = document.querySelector(this.element.dataset.sourceSelector)
	if(sourceElement) {
	    var headings = sourceElement.querySelectorAll("h2, h3")
	    var tocElement = this.element.querySelector('ol, ul')
	    var lastH2Li = null

	    // Add the current controller to sourceElement also.
	    sourceElement.dataset.controller = `${sourceElement.dataset.controller || ""} marketing--articles--navigator`.trim()

	    headings.forEach(heading => {
		var text = heading.innerText
		var id = text.toLowerCase().replace(/[^\w\s]/g, "").replace(/\s+/g, "-")

		// set heading
		heading.id = id

		// set anchor link
		var anchor = document.createElement("a")
		anchor.href = "#" + id
		anchor.className = "navigator-anchor"
		anchor.ariaLabel = "Link to this section"
		anchor.innerHTML = "🔗"
		anchor.setAttribute('data-action', "click->marketing--articles--navigator#copyLinkToClipboard")
		heading.append(anchor)

		// set navigator item
		var li = document.createElement("li")
		var a = document.createElement("a")
		a.href = "#" + heading.id
		a.textContent = text
		a.setAttribute('data-action', "click->marketing--articles--navigator#scrollToAnchor")
		li.appendChild(a)

		if (heading.tagName === "H2") {
		    // nested level 1
		    tocElement.appendChild(li)
		    lastH2Li = li
		} else if (heading.tagName === "H3") {
		    // nested level 2
		    if (lastH2Li) {
			let ul = lastH2Li.querySelector("ul")
			if (!ul) {
			    ul = document.createElement("ul")
			    lastH2Li.appendChild(ul)
			}
			ul.appendChild(li)
		    } else {
			tocElement.appendChild(li)
		    }
		}
	    })

	    this.element.dataset.setupComplete = 'true'
	}
    }

    copyLinkToClipboard(e) {
	e.preventDefault()
	var url = window.location.origin + window.location.pathname + event.currentTarget.getAttribute("href")
	if (navigator.clipboard && window.isSecureContext) {
	    navigator.clipboard.writeText(url)
	}
    }

    scrollToAnchor(e) {
	e.preventDefault()
	document.querySelector(event.currentTarget.getAttribute('href')).scrollIntoView({ behavior: "smooth" })
    }

    connectHeadingObserver() {
	var sourceElement = document.querySelector(this.element.dataset.sourceSelector)
	if(sourceElement) {
	    var headings = sourceElement.querySelectorAll("h2, h3")

	    var topRootMargin = 0
	    var bottomRootMargin = 0
	    if (headings[0]) {
		const scrollMarginTop = window.getComputedStyle(headings[0]).scrollMarginTop
		if (scrollMarginTop && scrollMarginTop !== "0px") {
		    topRootMargin = parseFloat(scrollMarginTop)
		}

		var bottomRootMargin = window.innerHeight - topRootMargin - 120
	    }

	    this.observer = new IntersectionObserver((entries) => {
		entries.forEach(entry => {
		    if (entry.isIntersecting) {
			this.highlightLink(entry.target.id)
		    }
		})
	    }, {
		rootMargin: `-${topRootMargin}px 0% -${bottomRootMargin}px 0%` // Adjusts the "trigger zone" for the heading at the top
	    })

	    headings.forEach(heading => this.observer.observe(heading))
	}

    }

    disconnectHeadingObserver() {
	if (this.observer) {
	    this.observer.disconnect()
	}
    }

    highlightLink(heading_id) {
	var tocElementLinks = this.element.querySelectorAll('ol a, ul a')
	tocElementLinks.forEach(link => {
	    link.classList.remove("active")
	    if(link.getAttribute("href") === "#" + heading_id) {
		link.classList.add("active")
	    }
	})
    }
}
